import { LoadableLazy } from '@confluence/loadable';
export type { BulkDeletePagesActionProps } from '../src/Delete/BulkDeletePagesAction.tsx';
export const BulkDeletePagesActionLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkDeletePagesActionLoader" */ '../src/Delete/BulkDeletePagesAction.tsx'
			)
		).BulkDeletePagesAction,
});
